const DELETE = 'DELETE_ITEM';
const SEND = 'SEND_ITEM';

export { DELETE, SEND };